// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_eQi","cls2":"ReportList-cls2_EnQ ReportList-cls1_eQi"};